import i18next from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';
import en from '@/locales/en.json';
import zh from '@/locales/zh.json';

export const i18nConfig = {
  resources: {
    en: {
      translation: en,
    },
    zh: {
      translation: zh,
    },
  },
  fallbackLng: 'en',
  defaultNS: 'translation',
  detection: {
    order: ['localStorage', 'navigator'],
    caches: ['localStorage'],
  },
  interpolation: {
    escapeValue: false,
  },
};

export function initI18n() {
  if (!i18next.isInitialized) {
    i18next.use(LanguageDetector).use(initReactI18next).init(i18nConfig);
  }

  return i18next;
}
